import { useBack } from "../http";
import { ExternalCompanyDTO } from "../types/ExternalCompanyDTO";

export class ExternalCompanyService {
	constructor() {}
	axiosInstance = useBack();

	async getAll() {
		try {
			const response = await this.axiosInstance.get<ExternalCompanyDTO[]>('/external-company');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as empresas externas`, error);
			return undefined;
		}
	}

	async create(company: ExternalCompanyDTO) {
		try {
			const response = await this.axiosInstance.post(`/external-company`, company);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível criar a empresa externa`, error);
			return undefined;
		}
	}

	async delete(id: number) {
		try {
			const response = await this.axiosInstance.delete(`/external-company/${id}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível apagar a empresa externa`, error);
			return undefined;
		}
	}
}